import { useEffect, useState } from "react";
import { api, fmtPrice } from "@/lib/api";
import { TrendingUp, TrendingDown, MinusCircle } from "lucide-react";

export default function RatesTicker() {
  const [rates, setRates] = useState([]);

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        const { data } = await api.get("/market/rates");
        if (mounted) setRates(data.rates);
      } catch {
        /* ignore */
      }
    };
    load();
    const t = setInterval(load, 5000);
    return () => {
      mounted = false;
      clearInterval(t);
    };
  }, []);

  if (rates.length === 0) {
    return (
      <div className="h-10 border-y border-subtle bg-card flex items-center px-4 text-xs text-muted-foreground">
        Connecting to market feed…
      </div>
    );
  }

  const marketOpen = !!rates[0].market_open;
  const items = [...rates, ...rates]; // duplicate for seamless scroll

  return (
    <div
      className="border-y border-subtle bg-card overflow-hidden relative"
      data-testid="rates-ticker"
      data-market-open={marketOpen ? "1" : "0"}
    >
      {!marketOpen && (
        <div
          className="absolute left-0 top-0 bottom-0 z-10 flex items-center gap-2 px-4 bg-card border-r border-subtle"
          data-testid="ticker-closed-badge"
        >
          <MinusCircle className="w-3.5 h-3.5 text-warning" />
          <span className="text-[10px] font-semibold uppercase tracking-widest text-warning whitespace-nowrap">
            Market Closed
          </span>
        </div>
      )}
      <div
        className={`ticker-track py-2.5 ${marketOpen ? "" : "ticker-frozen"}`}
        style={!marketOpen ? { animationPlayState: "paused", paddingLeft: 160, opacity: 0.55 } : undefined}
      >
        {items.map((r, i) => {
          const up = r.change >= 0;
          const priceColor = marketOpen ? "text-foreground" : "text-muted-foreground";
          return (
            <div
              key={`${r.symbol}-${i}`}
              className="flex items-center gap-3 px-6 border-r border-subtle"
              data-testid={`ticker-${r.symbol.replace("/", "-")}`}
            >
              <span
                className={`text-xs font-semibold tracking-wider ${
                  marketOpen ? "text-foreground" : "text-muted-foreground"
                }`}
              >
                {r.symbol}
              </span>
              <span className={`font-mono-num text-sm ${priceColor}`}>
                {fmtPrice(r.symbol, r.mid)}
              </span>
              {marketOpen ? (
                <span
                  className={`flex items-center gap-1 font-mono-num text-xs ${
                    up ? "text-profit" : "text-loss"
                  }`}
                >
                  {up ? <TrendingUp className="w-3 h-3" /> : <TrendingDown className="w-3 h-3" />}
                  {up ? "+" : ""}
                  {r.change_pct.toFixed(3)}%
                </span>
              ) : (
                <span className="flex items-center gap-1 font-mono-num text-xs text-muted-foreground uppercase tracking-widest">
                  <MinusCircle className="w-3 h-3" />
                  frozen
                </span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
